var app = angular.module('app',['ui.select', 'ngSanitize']);

app.factory('globals', [function() {

	var globals = {
		minimumAmount : 5000,
		maximumAmount : 150000
	};

	return globals;

}]);


/** TRENGO **/
$('.trengo-button').on('click', function(event) {
	event.preventDefault();
});

window.CW_API = window.CW_API || {};
window.CW_API.on_chat_status_changed = function (status) {
	$('.status').text(status);
};
/** END TRENGO **/